import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { KnBrCustomerContextAdapter } from 'src/store/kn-br-customer-context/kn-br-customer-context.adapter';

@Injectable()
export class KnBrSalesAreaInterceptor implements HttpInterceptor {
  constructor(private customerContextAdapter: KnBrCustomerContextAdapter) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let modifiedRequest = req;

    try {
      const salesArea = this.customerContextAdapter.getSalesArea();
      const currency = this.customerContextAdapter.getCurrency();
      const params: Record<string, string> = {};

      if (salesArea) {
        params['salesArea'] = salesArea;
      }
      if (currency) {
        params['curr'] = currency;
      }

      if (Object.keys(params).length > 0) {
        modifiedRequest = req.clone({ setParams: params });
      }
    } catch (error) {
      console.warn('[KnBrSalesAreaInterceptor] Failed to get context from storage:', error);
    }

    return next.handle(modifiedRequest);
  }
}
